import React, { useEffect } from 'react';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import Loader from 'src/components/Loader';
import {
  useAssetNotesActionsFromContext,
  useAssetNotesDataFromContext,
} from 'src/pages/Asset/Context/AssetNotesContext';

const AssetNotes = ({ asset, onFetchAssetData }: any) => {
  const { notes, loadingNotesDocs } = useAssetNotesDataFromContext();

  const { fetchNotes, saveNote, updateNote, deleteNote, clearNotesState } =
    useAssetNotesActionsFromContext();

  useEffect(() => {
    clearNotesState();
    fetchNotes(asset.id);
  }, [asset.id]);

  const handleSaveNote = async (note: any) => {
    await saveNote(note, asset.id);
    await onFetchAssetData();
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, asset.id);
    await onFetchAssetData();
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, asset.id);
    await onFetchAssetData();
  };

  return loadingNotesDocs ? (
    <Loader />
  ) : (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={asset.name}
      from="assets"
    />
  );
};

export default AssetNotes;
